import { z } from "zod";
export const AdvancedFeatureSchema = z.enum(["customTheming", "transcription"]);
export const AppTypeSchema = z.object({
    name: z.enum(["free", "paid", "standalone", "unregistered"]),
    showBranding: z.boolean(),
    /** null means unlimited; 0 means unregistered. */
    maxPeers: z.number().int().nonnegative().nullable(),
    /** Unix milliseconds; null means no known expiry. */
    expiresAt: z.number().int().nonnegative().nullable(),
    /** Instance availability, independent of the current user's role. */
    advancedFeatures: z.array(AdvancedFeatureSchema),
});
import { PriviligesSchema, RoleNoPasswordSchema } from "./permissions.js";
import { AppSettingsSchema } from "./settings.js";
const RegisteredAppTypeSchema = AppTypeSchema.extend({
    name: z.enum(["free", "paid", "standalone"]),
});
const common = {
    permissions: RoleNoPasswordSchema.extend({ privileges: PriviligesSchema }),
    andorUUID: z.string(),
    passwordRecovery: z.boolean(),
    /**
     * Set when the request reached a former address of the app: it moved to
     * `domain` and the old address keeps redirecting until `expiresAt` (Unix
     * ms). Clients navigate there; sign-ins do not carry over to the new origin.
     */
    movedTo: z.object({
        domain: z.string(),
        expiresAt: z.number().int().nonnegative(),
    }).optional(),
};
export const ReadyStartupSchema = z.object({
    ...common,
    status: z.literal("ready"),
    type: RegisteredAppTypeSchema,
    settings: AppSettingsSchema,
});
export const GetStartupSchema = z.discriminatedUnion("status", [
    z.object({
        ...common,
        status: z.literal("unregistered"),
        type: AppTypeSchema.extend({ name: z.literal("unregistered") }),
        settings: z.null(),
        passwordRecovery: z.literal(false),
    }),
    z.object({
        ...common,
        status: z.literal("setup-required"),
        type: RegisteredAppTypeSchema,
        settings: z.null(),
        passwordRecovery: z.literal(false),
    }),
    ReadyStartupSchema,
]);
